import { render, staticRenderFns } from "./ErrorsLayouts.vue?vue&type=template&id=36342f10&"
import script from "./ErrorsLayouts.vue?vue&type=script&lang=js&"
export * from "./ErrorsLayouts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports